module.exports = __webpack_public_path__ + "img/d4ad639.png";